import LoginLogs from "./LoginLogs";

export default LoginLogs;
